<template>
  <b-card-code title="">
    <div class="row mb-2">
      <div class="col-lg-3">
        <h4 class="mt-2">
          Aktív alkalmazottak listája
        </h4>
      </div>
      <div class="col-lg-9 text-right">
        <button
          class="btn btn-primary mr-0 mr-md-2 mt-2"
          @click="$bvModal.show('employee_export_modal')"
        >
          Excel lekérés
        </button>
        <button
          class="btn btn-primary mr-0 mr-md-2 mt-2"
          @click="$bvModal.show('employee_edit_group');"
        >
          Csoportos adat frissítés
        </button>
        <button
          class="btn btn-primary mr-0 mr-md-2 mt-2"
          @click="$bvModal.show('employee_documents');"
        >
          Csoportos dokumentumok
        </button>
        <button
          class="btn btn-primary mr-0 mr-md-2 mt-2"
          @click="$router.push('/employee/create')"
        >
          Alkalmazott létrehozás
        </button>
        <button
          class="btn btn-primary mr-0 mr-md-2 mt-2"
          @click="$router.push('/employee/archive')"
        >
          Archivált alkalmazottak
        </button>
      </div>
      <div class="col-lg-12 mt-2 text-right">
        <b-badge
          variant="primary"
          class="mr-1"
        >
          Összes alkalmazott {{ rows.length }} fő
        </b-badge>
        <b-badge
          variant="primary"
          class="mr-1"
        >
          Monolit Épszer alkalmazott {{ getEmployeeNumberInCompany('Monolit Épszer Kft.') }} fő
        </b-badge>
        <b-badge
          variant="primary"
          class="mr-1"
        >
          Monolit Profi alkalmazott {{ getEmployeeNumberInCompany('Monolit Profi Kft.') }} fő
        </b-badge>
      </div>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'active'"
          class="text-nowrap"
        >
          <span
            v-if="props.row.active == 1"
            class="text-nowrap"
          >Aktív</span>
          <span
            v-else
            class="text-nowrap"
          >Inaktív</span>
        </div>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'salary'">
          <span>{{ parseInt(props.row.salary).toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }} Ft</span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="$router.push('/employee/edit/'+props.row.id)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Szerkesztés</span>
              </b-dropdown-item>
              <b-dropdown-item @click="archiveThisUser(props.row.id)">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Archiválás</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-else-if="props.column.field === 'name'">
          <span
            style="cursor:pointer"
            @click="selectedData = props.row;$bvModal.show('employee_data');getCarrierData(props.row.tax_number)"
          >{{ props.row.name }}</span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Mutasd 1-től
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['25','50','100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap ">-ig a {{ props.total }} elemet </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal
      id="employee_edit_group"
      title="Csoportos adat frissítés"
      size="lg"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-form-group
          label="Adat módosítás típusa"
          label-for="multiple_edit_type"
          class="col-lg-12"
        >
          <small>Adatmódosítás típusa</small>
          <b-form-select
            id="document_type"
            v-model="multiple_edit_type"
            :options="['Bér módosítás', 'Orvosi alkalmassági', 'Munkavédelmi képzés']"
            placeholder="Adatmódosítás típusa"
          />
        </b-form-group>
        <div
          v-if="multiple_edit_type === 'Bér módosítás'"
          class="row col-lg-12 mt-2"
        >
          <table class="table col-lg-12">
            <tr>
              <td>Bérszint</td>
              <td>Új bér</td>
              <td>Bér szövegesen</td>
            </tr>
            <tr
              v-for="(salary, index) in multiple_salary"
              :key="index"
            >
              <td><b-form-input
                v-model="multiple_salary[index]"
                type="number"
              /></td>
              <td><b-form-input
                v-model="new_salary[index]"
                type="number"
              /></td>
              <td><b-form-input
                v-model="new_salary_text[index]"
                type="text"
              /></td>
            </tr>
          </table>
          <hr class="w-100 mb-3">
          <div class="row w-100 pl-2 pr-2">
            <div class="col-lg-4">
              <b-form-group
                label="Bér módosítás dátuma"
                label-for="salary_date"
                class="col-lg-12"
              >
                <small>Bér módosítás dátuma</small>
                <b-form-input
                  v-model="salary_date"
                  type="date"
                />
              </b-form-group>
            </div>
            <div class="col-lg-4">
              <b-form-group
                label="Szerződés dátuma"
                label-for="salary_date"
                class="col-lg-12"
              >
                <small>Szerződés dátuma</small>
                <b-form-input
                  v-model="salary_contract_date"
                  type="date"
                />
              </b-form-group>
            </div>
          </div>
          <hr class="w-100 mb-3">
          <p class="text-center w-100">
            <button
              class="btn btn-primary"
              @click="updateSalary()"
            >
              Frissítésé és munkaszerződés generálás
            </button>
          </p>
        </div>
        <div
          v-if="multiple_edit_type === 'Munkavédelmi képzés'"
          class="row col-lg-12 mt-2"
        >
          <b-form-group
            label=""
            label-for="osh_old_date"
            class="col-lg-12"
          >
            <small>Megváltoztatni kívánt munkavédelmi ideje</small>
            <b-form-input
              v-model="osh_old_date"
              type="date"
            />
          </b-form-group>
          <b-form-group
            label-for="osh_new_date"
            class="col-lg-12 mt-2"
          >
            <small>Új munkavédelmi képezés ideje</small>
            <b-form-input
              v-model="osh_new_date"
              type="date"
            />
          </b-form-group>
          <b-form-group
            label=""
            label-for="osh_change_employee"
            class="col-lg-12 mt-2"
          >
            <small>Alkalmazottak akikre vonatkozik még</small>
            <b-form-select
              id="osh_change_employee"
              v-model="osh_change_employee"
              class="col-lg-12"
              :options="rows"
              multiple
              style="height: 200px;"
              text-field="name"
              value-field="id"
            />
          </b-form-group>
          <p class="text-center w-100 mt-2">
            <button
              class="btn btn-primary btn-sm"
              @click="updateOSH()"
            >
              Frissítés
            </button>
          </p>
        </div>
        <div
          v-if="multiple_edit_type === 'Orvosi alkalmassági'"
          class="row col-lg-12 mt-2"
        >
          <b-form-group
            label=""
            label-for="medical_old_date"
            class="col-lg-12"
          >
            <small>Megváltoztatni kívánt orvosi alkalmassági ideje</small>
            <b-form-input
              v-model="medical_old_date"
              type="date"
            />
          </b-form-group>
          <b-form-group
            label-for="medical_new_date"
            class="col-lg-12 mt-2"
          >
            <small>Új orvosi alkalmassági ideje</small>
            <b-form-input
              v-model="medical_new_date"
              type="date"
            />
          </b-form-group>
          <b-form-group
            label=""
            label-for="medical_change_employee"
            class="col-lg-12 mt-2"
          >
            <small>Alkalmazottak akikre vonatkozik még</small>
            <b-form-select
              id="medical_change_employee"
              v-model="medical_change_employee"
              class="col-lg-12"
              :options="rows"
              multiple
              style="height: 200px;"
              text-field="name"
              value-field="id"
            />
          </b-form-group>
          <p class="text-center w-100 mt-2">
            <button
              class="btn btn-primary btn-sm"
              @click="updateMedical()"
            >
              Frissítés
            </button>
          </p>
        </div>
      </b-row>
    </b-modal>
    <b-modal
      id="employee_documents"
      title="Alkalmazotti dokumentumok"
      size="sm"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-form-group
          label="Dokumentum megnevezése"
          label-for="document_type"
          class="col-lg-12"
        >
          <small>Dokumentum megnevezése</small>
          <b-form-select
            id="document_type"
            v-model="document_type"
            :options="document_types"
            placeholder="Dokumentum megnevezése"
          />
        </b-form-group>
        <b-form-group
          v-if="document_type == 'osh_training_logbook'"
          label="Melyik cég dolgozóinak"
          label-for="monolit_type"
          class="col-lg-12 mt-2"
        >
          <small>Melyik cég dolgozóinak</small>
          <b-form-select
            id="monolit_type"
            v-model="monolit_type"
            :options="['Monolit Épszer Kft.', 'Monolit Profi Kft.']"
            placeholder="Melyik cég dolgozóinak"
          />
        </b-form-group>
        <button
          class="btn btn-primary col-lg-12 mt-2"
          @click="generate"
        >
          Generálás
        </button>
      </b-row>
    </b-modal>
    <b-modal
      id="employee_data"
      title="Alkalmazott adatai"
      size="lg"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-col
          lg="12"
          class="mt-1"
        >
          <b>Személyes adatok</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Név: <b>{{ selectedData.name }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Lakcím: <b>{{ selectedData.address }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Anyja neve: <b>{{ selectedData.mother_name }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Születési hely: <b>{{ selectedData.birth_location }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Születési idő: <b>{{ selectedData.birth_date }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Telefonszám: <b>{{ selectedData.phone_number }}</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>Okmány adatok</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          TAJ szám: <b>{{ selectedData.health_insurance_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Adóazonosító  szám: <b>{{ selectedData.tax_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Szem.ig.szám: <b>{{ selectedData.personal_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Személyi szám (azonosító): <b>{{ selectedData.personal_number_sec }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Lakcímkártya száma: <b>{{ selectedData.address_of_residence }}</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>Egyéb</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-1"
        >
          Megjegyzés: <b>{{ selectedData.comment }}</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>Munka adatok</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Aktív munkavállaló: <b v-if="selectedData.active">Aktív</b>
          <b v-else>inaktív</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Cég: <b>{{ selectedData.monolit }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Munkakör: <b>{{ selectedData.work }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          FEOR szám: <b>{{ selectedData.feor_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Munkaszerződés dátuma: <b>{{ selectedData.work_contract }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Munkakezdés dátuma: <b>{{ selectedData.work_start }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Bruttó bér: <b v-if="selectedData.salary != null">{{ parseInt(selectedData.salary).toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }} Ft</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Bruttó bér (szövegesen): <b>{{ selectedData.salary_text }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Éjszakai pótlék: <b>{{ selectedData.night_supplement }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Éjszakai pótlék (szövegesen): <b>{{ selectedData.night_supplement_text }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Csoport szám: <b>{{ selectedData.group_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Bankszámlaszám: <b>{{ selectedData.bank_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Utazási támogatás: <b>{{ selectedData.travel_support }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Munkaidő: <b>{{ selectedData.work_hour }} óra</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Kilépés ideje: <b>{{ selectedData.exit_time }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Egészségügyi alkalmassági: <b>{{ selectedData.medical_fitness }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Munkavédelmi oktatás: <b>{{ selectedData.OSH }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Szakmája: <b>{{ selectedData.profession }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Legmagasabb iskolai végzettség: <b>{{ selectedData.education }}</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>Ruha méretek</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Ruha kiadás dátuma: <b>{{ selectedData.clothes_date }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Póló méret: <b>{{ selectedData.shirt_size }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Kabát méret: <b>{{ selectedData.top_clothes_size }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Eső kabát méret: <b>{{ selectedData.waterproof_size }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Nadrág méret: <b>{{ selectedData.bottom_clothes_size }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Bakancs méret: <b>{{ selectedData.boots_size }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Csizma méret: <b>{{ selectedData.shoes_size }}</b>
        </b-col>
        <hr class="col-lg-12">
        <b-col
          lg="12"
          class="mt-1"
        >
          <b>Családi adatok</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Kapcsolatban: <b>{{ selectedData.partnership }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Baleset esetén értesítendő személy neve: <b>{{ selectedData.notified_person }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Rokoni kapcsolat megnevezése: <b>{{ selectedData.notified_person_family_relationship }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Értesítendő személy telefonszáma: <b>{{ selectedData.notified_person_phone }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Adó kedvezményt igényel: <b>{{ selectedData.tax_reducation }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Adó kedvezmény: <b>{{ selectedData.tax }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Adó kedvezmény összege: <b>{{ selectedData.tax_reduction_price }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Kiskorú gyermekek száma (szabadsághoz): <b>{{ selectedData.underage }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Közeli hozzátartozó meghalt idén: <b>{{ selectedData.close_relative_died }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_1 != null && selectedData.children_name_1 != ''"
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>1.) Gyerek adatok</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_1 != null && selectedData.children_name_1 != ''"
          lg="6"
          class="mt-1"
        >
          1. Gyermek neve: <b>{{ selectedData.children_name_1 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_1 != null && selectedData.children_name_1 != ''"
          lg="6"
          class="mt-1"
        >
          1. Gyermek születési helye: <b>{{ selectedData.children_birth_place_1 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_1 != null && selectedData.children_name_1 != ''"
          lg="6"
          class="mt-1"
        >
          1. Gyermek születési dátum: <b>{{ selectedData.children_birth_date_1 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_1 != null && selectedData.children_name_1 != ''"
          lg="6"
          class="mt-1"
        >
          1. Gyermek TAJ szám: <b>{{ selectedData.children_health_insurance_number_1 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_1 != null && selectedData.children_name_1 != ''"
          lg="6"
          class="mt-1"
        >
          1. Gyermek adószám: <b>{{ selectedData.children_tax_number_1 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_1 != null && selectedData.children_name_1 != ''"
          lg="6"
          class="mt-1"
        >
          1. Gyermek anyja neve: <b>{{ selectedData.children_mother_name_1 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_2 != null && selectedData.children_name_2 != ''"
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>2.) Gyerek adatok</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_2 != null && selectedData.children_name_2 != ''"
          lg="6"
          class="mt-1"
        >
          2. Gyermek neve: <b>{{ selectedData.children_name_2 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_2 != null && selectedData.children_name_2 != ''"
          lg="6"
          class="mt-1"
        >
          2. Gyermek születési helye: <b>{{ selectedData.children_birth_place_2 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_2 != null && selectedData.children_name_2 != ''"
          lg="6"
          class="mt-1"
        >
          2. Gyermek születési dátum: <b>{{ selectedData.children_birth_date_2 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_2 != null && selectedData.children_name_2 != ''"
          lg="6"
          class="mt-1"
        >
          2. Gyermek TAJ szám: <b>{{ selectedData.children_health_insurance_number_2 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_2 != null && selectedData.children_name_2 != ''"
          lg="6"
          class="mt-1"
        >
          2. Gyermek adószám: <b>{{ selectedData.children_tax_number_2 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_2 != null && selectedData.children_name_2 != ''"
          lg="6"
          class="mt-1"
        >
          2. Gyermek anyja neve: <b>{{ selectedData.children_mother_name_2 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_3 != null && selectedData.children_name_3 != ''"
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>3.) Gyerek adatok</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_3 != null && selectedData.children_name_3 != ''"
          lg="6"
          class="mt-1"
        >
          3. Gyermek neve: <b>{{ selectedData.children_name_3 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_3 != null && selectedData.children_name_3 != ''"
          lg="6"
          class="mt-1"
        >
          3. Gyermek születési helye: <b>{{ selectedData.children_birth_place_3 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_3 != null && selectedData.children_name_3 != ''"
          lg="6"
          class="mt-1"
        >
          3. Gyermek születési dátum: <b>{{ selectedData.children_birth_date_3 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_3 != null && selectedData.children_name_3 != ''"
          lg="6"
          class="mt-1"
        >
          3. Gyermek TAJ szám: <b>{{ selectedData.children_health_insurance_number_3 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_3 != null && selectedData.children_name_3 != ''"
          lg="6"
          class="mt-1"
        >
          3. Gyermek adószám: <b>{{ selectedData.children_tax_number_3 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_3 != null && selectedData.children_name_3 != ''"
          lg="6"
          class="mt-1"
        >
          3. Gyermek anyja neve: <b>{{ selectedData.children_mother_name_3 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_4 != null && selectedData.children_name_4 != ''"
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>4.) Gyerek adatok</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_4 != null && selectedData.children_name_4 != ''"
          lg="6"
          class="mt-1"
        >
          4. Gyermek neve: <b>{{ selectedData.children_name_4 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_4 != null && selectedData.children_name_4 != ''"
          lg="6"
          class="mt-1"
        >
          4. Gyermek születési helye: <b>{{ selectedData.children_birth_place_4 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_4 != null && selectedData.children_name_4 != ''"
          lg="6"
          class="mt-1"
        >
          4. Gyermek születési dátum: <b>{{ selectedData.children_birth_date_4 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_4 != null && selectedData.children_name_4 != ''"
          lg="6"
          class="mt-1"
        >
          4. Gyermek TAJ szám: <b>{{ selectedData.children_health_insurance_number_4 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_4 != null && selectedData.children_name_4 != ''"
          lg="6"
          class="mt-1"
        >
          4. Gyermek adószám: <b>{{ selectedData.children_tax_number_4 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_4 != null && selectedData.children_name_4 != ''"
          lg="6"
          class="mt-1"
        >
          4. Gyermek anyja neve: <b>{{ selectedData.children_mother_name_4 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_5 != null && selectedData.children_name_5 != ''"
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>5.) Gyerek adatok</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_5 != null && selectedData.children_name_5 != ''"
          lg="6"
          class="mt-1"
        >
          5. Gyermek neve: <b>{{ selectedData.children_name_5 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_5 != null && selectedData.children_name_5 != ''"
          lg="6"
          class="mt-1"
        >
          5. Gyermek születési helye: <b>{{ selectedData.children_birth_place_5 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_5 != null && selectedData.children_name_5 != ''"
          lg="6"
          class="mt-1"
        >
          5. Gyermek születési dátum: <b>{{ selectedData.children_birth_date_5 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_5 != null && selectedData.children_name_5 != ''"
          lg="6"
          class="mt-1"
        >
          5. Gyermek TAJ szám: <b>{{ selectedData.children_health_insurance_number_5 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_5 != null && selectedData.children_name_5 != ''"
          lg="6"
          class="mt-1"
        >
          5. Gyermek adószám: <b>{{ selectedData.children_tax_number_5 }}</b>
        </b-col>
        <b-col
          v-if="selectedData.children_name_5 != null && selectedData.children_name_5 != ''"
          lg="6"
          class="mt-1"
        >
          5. Gyermek anyja neve: <b>{{ selectedData.children_mother_name_5 }}</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-1"
        >
          <hr>
          <b>Karrier a cégnél:</b>
        </b-col>
        <b-col>
          <table class="table">
            <tr>
              <th>
                <b>Cég</b>
              </th>
              <th>
                <b>Beosztás</b>
              </th>
              <th>
                <b>Kezdés</b>
              </th>
              <th>
                <b>Befejezés</b>
              </th>
            </tr>
            <tr
              v-for="carrier in carrier_data"
              :key="carrier"
            >
              <td>{{ carrier.monolit }}</td>
              <td>{{ carrier.work }}</td>
              <td>{{ carrier.work_start }}</td>
              <td>{{ carrier.exit_time }}</td>
            </tr>
          </table>
        </b-col>
        <b-col
          lg="12"
          class="justify-content-end d-flex mt-2"
        >
          <button
            size="sm"
            class="btn btn-danger"
            @click="$bvModal.hide('employee_data')"
          >
            Bezár
          </button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="employee_export_modal"
      title="Excel export"
      size="sm"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-form-group
          label="Export típusa"
          label-for="export_type"
          class="col-lg-12"
        >
          <small>Milyen alkalmazottakat szeretnél exportálni?</small>
          <b-form-select
            id="export_type"
            v-model="export_type"
            :options="export_options"
            placeholder="Export típusa"
          />
        </b-form-group>
        <button
          class="btn btn-primary col-lg-12 mt-2"
          @click="exportEmployee()"
        >
          Export indítása
        </button>
      </b-row>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BBadge, BPagination, BFormSelect, BDropdown, BDropdownItem, BRow, BCol, BFormInput,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BBadge,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BFormInput,
  },
  data() {
    return {
      salary_date: null,
      salary_contract_date: null,
      carrier_data: [],
      pageLength: 25,
      dir: false,
      columns: [
        {
          label: 'Név',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés névre',
          },
        },
        {
          label: 'Munkakör',
          field: 'work',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés munkakörre',
          },
        },
        {
          label: 'Telefonszám',
          field: 'phone_number',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés telefonszámra',
          },
        },
        {
          label: 'Fizetés',
          field: 'salary',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés fizetésre',
          },
        },
        {
          label: 'Szakma',
          field: 'profession',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés szakmára',
          },
        },
        {
          label: 'Cég',
          field: 'monolit',
          filterOptions: {
            enabled: true,
            placeholder: 'Keresés cégre',
          },
        },
        {
          label: 'Aktív munkavállaló',
          field: 'active',
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: '',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      selectedData: {},
      document_types: [
        {
          text: 'Munkavédelmi oktatási napló',
          value: 'osh_training_logbook',
        },
        {
          text: 'Adategyeztető lap',
          value: 'contract_data_reconciliation_sheet',
        },
      ],
      document_type: '',
      monolit_type: '',
      multiple_edit_type: '',
      multiple_salary: [],
      new_salary: [],
      new_salary_text: [],
      osh_change_employee: [],
      osh_old_date: '',
      osh_new_date: '',
      medical_new_date: '',
      medical_old_date: '',
      medical_change_employee: [],
      export_type: 'active',
      export_options: [
        {
          text: 'Csak aktív alkalmazottak',
          value: 'active',
        },
        {
          text: 'Összes alkalmazott',
          value: 'all',
        },
      ],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        Folyamatban: 'light-success',
        Késésben: 'light-warning',
        Lejárt: 'light-danger',
        Kész: 'light-info',
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    medical_old_date(val) {
      if (val !== null) {
        axios({
          method: 'get',
          // eslint-disable-next-line camelcase
          url: `employee/list_date_medical/${val}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }).then(response => {
          this.medical_change_employee = response.data
        })
      }
    },
    osh_old_date(val) {
      if (val !== null) {
        axios({
          method: 'get',
          // eslint-disable-next-line camelcase
          url: `employee/list_date_osh/${val}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }).then(response => {
          this.osh_change_employee = response.data
        })
      }
    },
  },
  mounted() {
    this.loadUserList()
  },
  methods: {
    updateMedical() {
      axios({
        method: 'put',
        url: 'employee/multiple/update/medical',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          new_date: this.medical_new_date,
          old_date: this.medical_old_date,
          employee: this.medical_change_employee,
        },
      }).then(() => {
        this.loadUserList()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Orvosi alkalmassági adatok sikeresen frissítve lettek',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.$bvModal.hide('employee_edit_group')
      })
    },
    updateOSH() {
      axios({
        method: 'put',
        url: 'employee/multiple/update/osh',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          new_date: this.osh_new_date,
          old_date: this.osh_old_date,
          employee: this.osh_change_employee,
        },
      }).then(() => {
        this.loadUserList()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Munkavédelmi oktatás adatok sikeresen frissítve lettek',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.$bvModal.hide('employee_edit_group')
      })
    },
    updateSalary() {
      axios({
        method: 'post',
        url: 'employee/multiple/update/salary',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        responseType: 'blob',
        data: {
          new_salary: this.new_salary,
          new_salary_text: this.new_salary_text,
          old_salary: this.multiple_salary,
          contract_modification_date: this.salary_date,
          contract_modification_create: this.salary_contract_date,
        },
      }).then(res => {
        this.salary_contract_date = ''
        this.salary_date = ''
        this.loadUserList()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Bérek sikeresen frissítve lettek',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.$bvModal.hide('employee_edit_group')

        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Csoportos munkaszerződés módosítás.pdf')
        document.body.appendChild(link)
        link.click()
      })
    },
    getMultipleSalary() {
      this.multiple_salary = []
      this.new_salary = []
      this.new_salary_text = []
      this.rows.forEach(row => {
        if (this.multiple_salary.indexOf(row.salary) === -1 && row.salary !== null) this.multiple_salary.push(row.salary)
        if (this.new_salary.indexOf(row.salary) === -1 && row.salary !== null) {
          this.new_salary.push(row.salary)
          this.new_salary_text.push(null)
        }
      })
      this.multiple_salary.sort((a, b) => b - a)
      this.new_salary.sort((a, b) => b - a)
    },
    generate() {
      axios({
        method: 'post',
        url: `employee/document/create/${this.document_type}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          monolit_type: this.monolit_type,
        },
        responseType: 'blob',
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        if (this.document_type === 'osh_training_logbook') {
          link.setAttribute('download', 'Éves munkavédelmi oktatási napló.pdf')
        } else if (this.document_type === 'contract_data_reconciliation_sheet') {
          link.setAttribute('download', 'Adategyeztető lap.pdf')
        }
        document.body.appendChild(link)
        link.click()
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Minden mező kitöltése kötelező!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    },
    // eslint-disable-next-line camelcase
    getCarrierData(tax_number) {
      axios({
        method: 'get',
        // eslint-disable-next-line camelcase
        url: `employee/carrier/${tax_number}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.carrier_data = response.data
      })
    },
    archiveThisUser(id) {
      axios({
        method: 'delete',
        url: `employee/archive/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.loadUserList()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Alkalmazott sikeresen archiválva lett',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      })
    },
    getEmployeeNumberInCompany(company_name) {
      const rows = this.rows.filter(row => row.monolit === company_name)
      return rows.length
    },
    loadUserList() {
      axios({
        method: 'get',
        url: 'employee/list',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.rows = response.data
        this.getMultipleSalary()
      })
    },
    exportEmployee() {
      axios({
        method: 'post',
        url: 'employee/export',
        responseType: 'blob',
        data: {
          type: this.export_type,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Alkalmazott export.xlsx')
        document.body.appendChild(link)
        link.click()
        this.$bvModal.hide('employee_export_modal')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Excel export sikeresen elindítva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
<style>
  .vue-form-wizard .wizard-card-footer .wizard-footer-right .wizard-btn::after{
    content: "►" !important;
  }
  .vue-form-wizard .wizard-card-footer .wizard-footer-left .wizard-btn::before{
    content: "◄" !important;
  }
</style>
